import mBaseModel from '@/models/mBaseModel';
import UtilsData from '@/utilities/UtilsData';
import formatter from '@/utilities/Formatter';
import moment from 'moment';
import UtilsObject from '@/utilities/UtilsObject';

import { ModelWithSmartProperties } from '@/models/ModelWithSmartProperties';
import { ModelFormatters } from '@/models/ModelFormatters';
import { ModelPropertyInfos } from '@/models/ModelPropertyInfos';

export default class mDealStacrCollateralInformation extends ModelWithSmartProperties {
  constructor(rawModelFields = {}) {
    super(rawModelFields);
    this.ats = {
      ...mDealStacrCollateralInformation.Defaults(),
    };

    this.defineModelProperty('ReferencePoolBalance', ModelPropertyInfos.DecimalNumber2Digits);
    this.defineModelProperty('Wac', ModelPropertyInfos.DecimalNumber);
    this.defineModelProperty('Wam', ModelPropertyInfos.IntegerNumber);
    this.defineModelProperty('Wala', ModelPropertyInfos.IntegerNumber);

    this.setRawFields({
      ...this.ats,
      ...rawModelFields
    });
  }

  // ##################################################
  // region Static Data
  static Defaults = () => {
    return {
      ReferencePoolBalance: 1000000000.0,
      Wac: 3.0,
      Wam: 357,
      Wala: 0.0
    };
  };

  static vocDbToLabel(dbName = null) {
    const ats = Object.freeze({
      ReferencePoolBalance: 'Reference Pool Balance',
      Wac: 'WAC',
      Wam: 'WAM',
      Wala: 'WALA',
    });
    // ##################################################
    if (dbName) {
      return UtilsObject.getByPath(ats, dbName);
    }
    return ats;
  }

  // endregion Static Data

  // ##################################################
  // region Validation
  validate() {
    const createErrorDescription = (msg, fieldName, fieldSysName) => {
      return {
        modelName: 'STACR',
        msg,
        field: fieldName,
        fieldSysName
      };
    };

    this._localValidationStatus = true;
    this._localValidationResults = [];

    // 'Reference Pool Balance' is a numeric value, where 1 < Balance < 999,999,999,999.99
    // NO default.									
    if (!(this.ReferencePoolBalance$ > 1 && this.ReferencePoolBalance$ < 1E12)) {
      this._localValidationResults.push(createErrorDescription(
        '0 < Balance < 1e12',
        mDealStacrCollateralInformation.vocDbToLabel('ReferencePoolBalance'),
        'ReferencePoolBalance'
      ));
    }

    // 'WAC' is an annual percentage, where 0 < WAC < 25… NO default. 						
    if (!(this.Wac$ > 0 && this.Wac$ < 25)) {
      this._localValidationResults.push(createErrorDescription(
        '0 < WAC < 25',
        mDealStacrCollateralInformation.vocDbToLabel('Wac'),
        'Wac'
      ));
    }

    // 'WAM' is an integer, where 0 < WAM <= 360… NO default.						
    if (!(this.Wam$ > 0 && this.Wam$ <= 360)) {
      this._localValidationResults.push(createErrorDescription(
        '0 < WAM <= 360',
        mDealStacrCollateralInformation.vocDbToLabel('Wam'),
        'Wam'
      ));
    }

    // 'WALA' is an integer, where 0 <= WALA <= 360-WAM… NO default.						
    if (!(this.Wala$ >= 0 && this.Wala$ <= (360 - this.Wam$))) {
      this._localValidationResults.push(createErrorDescription(
        '0 <= WALA <= 360-WAM',
        mDealStacrCollateralInformation.vocDbToLabel('Wala'),
        'Wala'
      ));
    }

    this._localValidationStatus = this._localValidationResults.length === 0;

    return this._localValidationResults;
  }

  // endregion Validation
  // ##################################################
}
